export default `float de(vec3 p){
    float s = 0.2; 
    float da = max (abs(p.x), abs(p.y));
    float db = max (abs(p.y), abs(p.z));
    float dc = max (abs(p.z), abs(p.x));
    return min(da,min(db,dc)) - s;
  }`